<template>
  <v-container>
    <pageTitle class="mb-6">Lägg till ny öl för provning</pageTitle>
    <v-autocomplete
      :items="systemetbolagetItems"
      :search-input.sync="search"
      class="mb-6"
      clearable
      flat
      hide-details
      item-text="namn"
      :loading="isLoading"
      label="Börja med att söka efter ölen ..."
      outlined
      prepend-inner-icon="mdi-magnify"
      v-model="systemetbolagetItem"
      return-object
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Börja skriv för att söka på ölets namn ...
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attr, on, item, selected }">
        {{ resultRow(item, true) }}
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title v-text="resultRow(item, false)"></v-list-item-title>
          <v-list-item-subtitle v-text="item.producent"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <v-text-field
      v-model="newBeer.name"
      label="Namn på öl"
      outlined
      prepend-inner-icon="mdi-beer"
    ></v-text-field>
    <v-text-field
      v-model="newBeer.brewery"
      label="Bryggeri/producent"
      outlined
      prepend-inner-icon="mdi-factory"
    ></v-text-field>
    <em v-if="beerID">Högerklicka på den STORA bilden från <a :href="queryURL + beerID" target="_blank">systembolagets produktvy</a> och kopiera sökvägen för bilden.</em>
    <v-text-field
      v-model="newBeer.img"
      label="Sökväg för bild från systembolaget"
      outlined
      prepend-inner-icon="mdi-image-search"
      hint="Kopiera sökvägen för den STORA bilden från systembolaget."
    ></v-text-field>
    <v-row no-gutters style="flex-wrap: nowrap;">
      <v-col cols="4">
        <v-img
          :src="newBeer.img"
          aspect-ratio="1.2"
          position="center bottom"
        ></v-img>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="newBeer.boughtBy"
          label="Köpt av"
          outlined
          prepend-inner-icon="mdi-account"
        ></v-text-field>
        <v-text-field
          v-model="newBeer.date"
          label="Datum för provning"
          outlined
          prepend-inner-icon="mdi-calendar"
        ></v-text-field>
        <v-btn color="primary" depressed :disabled="!isValid" @click="addNewData">Spara</v-btn>
        <v-btn :disabled="hasInput" @click="clearData" text>Rensa</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import pageTitle from '../components/PageTitle'
import _ from 'lodash'

  export default {
    components: {pageTitle},
    data () {
      return {
        beerID: '',
        isLoading: false,
        newBeer: {
          boughtBy: '',
          brewery: '',
          date: this.today(),
          id: '',
          img: '',
          name: '',
          systembolagetNr: 'noSystemetId'
        },
        systemetbolagetItems: [],
        systemetbolagetItem: null,
        queryURL: 'https://www.systembolaget.se/sok-dryck/?textQuery=',
        search: null,
        selectedBeer: {},
        tab: null
      }
    },
    computed: {
      hasInput: function () {
        const boughtBy = this.newBeer.boughtBy
        const brewery = this.newBeer.brewery
        const name = this.newBeer.name

        if (brewery.length > 0 || boughtBy.length > 0 || name.length > 0) {
          return false
        }
        return true
      },
      isValid: function () {
        let boughtBy = this.newBeer.boughtBy
        let brewery = this.newBeer.brewery
        let name = this.newBeer.name
        let hasImageUrl = this.checkImageURL(this.newBeer.img)

        if (brewery.length > 0 && boughtBy.length > 2 && name.length > 0 && hasImageUrl) {
          return true
        }

        return false
      }
    },
    methods: {
      addNewData: function () {
        if (!this.isValid) return

        this.sanatize()

        this.newBeer.id = this.createId(this.newBeer.name)

        if (this.systemetbolagetItem) {
          this.newBeer.systembolagetNr = this.systemetbolagetItem.nr
        }

        this.$store.dispatch('createNewData', this.newBeer)
        this.clearData()
      },
      checkImageURL (url) {
        const fileEXT = url.substring(url.lastIndexOf('.')+1, url.length) || url
        let hasFileExt = false

        if (fileEXT === 'jpg' || fileEXT === 'png') hasFileExt = true

        return hasFileExt
      },
      clearData () {
        this.newBeer.brewery = ''
        this.newBeer.id = ''
        this.newBeer.img = ''
        this.newBeer.name = ''
        this.newBeer.systembolagetNr = 'noSystemetId'
        // Clear search field.
        this.systemetbolagetItem = null
      },
      createId: function (beerName) {
        beerName = beerName.replace(/\s+/g, '_').toLowerCase()
        beerName = beerName.replace(/[åä]/g, 'a')
        beerName = beerName.replace(/[ö]/g, 'o')
        beerName = beerName.replace(/[^a-z0-9_-]/g, '')

        return beerName
      },
      populateFields (item) {
        this.newBeer.brewery = item.producent

        let name = item.namn
        if (item.namn2 && item.producent.includes(name)) {
          name = data.namn2
        }
        this.newBeer.name = name
        this.beerID = item.nr
      },
      resultRow (item, selected) {
        let result = ''
        if (item.namn) result = item.namn
        if (item.namn2) result = item.namn2
        if (item.namn && item.namn2) result = item.namn + ', ' + item.namn2

        if (selected) this.populateFields(item)

        return result
      },
      sanatize: function () {
        this.newBeer.name = this.newBeer.name.trim()
        this.newBeer.brewery = this.newBeer.brewery.trim()
        this.newBeer.boughtBy = this.newBeer.boughtBy.trim()
        this.newBeer.img = this.newBeer.img.trim()
      },
      today () {
        let now = new Date()
        now = now.toISOString().substring(0, 10)

        return now
      }
    },
    watch: {
      systemetbolagetItem (val) {
        if (val != null) this.tab = 0
        else this.tab = null
      },
      search (val) {
        // Items have already been loaded'
        if (this.systemetbolagetItems.length > 0) return

        this.isLoading = true

        // Lazily load input items
        fetch('https://api.3ol3.nu/api/beverages/beers/all')
          .then(res => res.json())
          .then(res => {
            this.systemetbolagetItems = res
          })
          .finally(() => (this.isLoading = false))
      },
    },
  }
</script>

<style lang="scss">
.image-url {
  position: absolute;
  width: 100%;
  left:0;
}
</style>
